import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { toAletheiaItem } from './aletheiaItemFallback'
import { type DniAnalysisTransformer } from './transformers'

export const addToWishlistTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'add_to_wishlist') return event
  if (platform === AnalyticsPlatforms.ALETHEIA) {
    return {
      eventName: 'add_to_wishlist',
      eventParams: {
        ...event.eventParams,
        items: event.eventParams.items?.map(item => toAletheiaItem(item, 'add_to_wishlist')),
      },
    }
  }
  return event
}
